type proxyPairMap = { [key: string]: string }

export const proxyToPairs: proxyPairMap = {
    "0x8A753747A1Fa494EC906cE90E9f37563A8AF630e" : "ETH / USD",
    "0xECe365B379E1dD183B20fc5f022230C044d51404" : "BTC / USD",
    "0xcf0f51ca2cDAecb464eeE4227f5295F2384F84ED" : "BNB / USD",
    "0xd8bD0a1cB028a31AA859A21A3758685a95dE4623" : "LINK / USD",
}